const PageHeader = ({ children }) => {
  return <h1 className="text-3xl font-semibold text-gray-900 mb-6 md:mb-8">{children}</h1>;
};

export default PageHeader;
